// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"41b58156","592":"295a5f8b"}[chunkId] + ".chunk.js";
};